import React from 'react'
import { useNavigate } from 'react-router-dom'

function truncateText(text, maxLength) {
  if (text.length <= maxLength) {
    return text;
  } else {
    return text.substring(0, maxLength - 3) + '...';
  }
}



function ServiceCard({
    icon,
    heading,
    content,
    btnText="Learn More",
    btnRef="/",
    iconBox=false
}) {
    const navigate= useNavigate()
    const para = truncateText(content,100)
  return (
    <div className="service-card py-4 px-3">
    <div className="service-card-info mt-3">
      
      <div className="profile-info px-3 d-flex flex-column gap-3 text-start ">
        
        {/* <div className='icon-container'>

        </div> */}
        {
          iconBox ?
          <div className='blue-box'></div>
          :
          <img src={icon} alt="" className='icon'/>
        }
          <h3 className='body-heading-w mt-1 color-light' style={{fontSize:"20px"}}>{heading}</h3>
          <p className="review-text body-paragraph ">{para}</p>
          {/* <button className='genral-btn' onClick={()=>{navigate(btnRef)}}>{btnText}</button> */}
      </div>
     
    </div>
</div>
  )
}

export default ServiceCard